import { ChevronDown } from 'lucide-react'

import { BannerWithTitle } from '@/components/banner-with-title'

import { CarbonSection } from './carbon'
import { DampingSection } from './damping'
import { MonitoringSection } from './monitoring'
import { PreservationSection } from './preservation'
import { RegenerationSection } from './regeneration'

export function Services() {
  return (
    <div className="bg-monochromatic-200 flex-1 pb-20">
      <div className="content-center px-5 md:px-10 xl:px-16 xl:pt-6 2xl:px-24">
        <BannerWithTitle
          title="Inovação em serviços ambientais"
          className="bg-services bg-center"
        />
      </div>

      <main className="flex flex-col gap-6">
        <div className="w-full p-5 text-center xl:my-16 xl:px-40 2xl:my-20 2xl:px-72">
          <div className="space-y-7">
            <p className="paragraph">
              A 6BIOS cria, captura e entrega valor aos seus clientes mediante
              um conjunto inovador de serviços de alta tecnologia focados na
              captação global e distribuição estruturada, segura e acreditada de
              recursos financeiros destinados à preservação, regeneração,
              amortecimento ambiental, monitoração e operação de créditos de
              carbono nos biomas brasileiros.
            </p>

            <ChevronDown className="text-bios-primary mx-auto size-8 animate-bounce" />
          </div>
        </div>
        <div className="space-y-36 2xl:space-y-44">
          <PreservationSection />
          <RegenerationSection />
          <DampingSection />
          <CarbonSection />
          <MonitoringSection />
        </div>
      </main>
    </div>
  )
}
